var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "crm-busca-vinculo"
  }, [_c('b-form-group', {
    attrs: {
      "label": _vm.label
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": _vm.placeholder,
      "autocomplete": "off"
    },
    on: {
      "input": _vm.debouncedBuscar
    },
    model: {
      value: _vm.termo,
      callback: function callback($$v) {
        _vm.termo = $$v;
      },
      expression: "termo"
    }
  })], 1), _vm.permiteCriarContato ? _c('div', {
    staticClass: "crm-busca-toolbar mb-3"
  }, [_c('button', {
    staticClass: "btn btn-light-primary btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.abrirCriacaoContato
    }
  }, [_vm._v(" Criar contato ")])]) : _vm._e(), _vm.selecionado ? _c('div', {
    staticClass: "crm-busca-selecionado mb-3"
  }, [_c('div', [_c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v(" " + _vm._s(_vm.tipoLabel(_vm.selecionado.tipo)) + " ")]), _c('strong', [_vm._v(_vm._s(_vm.selecionado.label))])]), _c('div', {
    staticClass: "crm-busca-acoes"
  }, [_c('button', {
    staticClass: "btn btn-light btn-xs",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.limpar
    }
  }, [_vm._v(" Trocar ")])])]) : _vm._e(), _vm.loading ? _c('div', {
    staticClass: "text-muted mb-3"
  }, [_vm._v("Buscando...")]) : _vm.erro ? _c('div', {
    staticClass: "alert alert-light-danger py-2 mb-3"
  }, [_vm._v(" " + _vm._s(_vm.erro) + " ")]) : _vm.termoBuscado && !_vm.totalResultados ? _c('div', {
    staticClass: "crm-busca-vazio"
  }, [_c('span', [_vm._v(" Nenhum cliente ou contato encontrado para "), _c('strong', [_vm._v(_vm._s(_vm.termoBuscado))]), _vm._v(". ")])]) : _vm.totalResultados ? _c('div', {
    staticClass: "crm-busca-resultados"
  }, [_vm.contatos.length ? _c('div', {
    staticClass: "crm-busca-grupo"
  }, [_c('small', {
    staticClass: "text-muted text-uppercase"
  }, [_vm._v("Contatos CRM")]), _vm._l(_vm.contatos, function (contato) {
    return _c('button', {
      key: 'contato-' + contato.id_crm_contato,
      staticClass: "crm-busca-item",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.selecionar('contato', contato);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(contato.nome))]), _c('small', [_vm._v(_vm._s(_vm.contatoDetalhe(contato)))])]);
  })], 2) : _vm._e(), _vm.pessoas.length ? _c('div', {
    staticClass: "crm-busca-grupo"
  }, [_c('small', {
    staticClass: "text-muted text-uppercase"
  }, [_vm._v("Pessoas existentes")]), _vm._l(_vm.pessoas, function (pessoa) {
    return _c('button', {
      key: 'pessoa-' + pessoa.id_pessoa,
      staticClass: "crm-busca-item",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.selecionar('pessoa', pessoa);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(pessoa.nome || pessoa.nome_fantasia))]), _c('small', [_vm._v(_vm._s(_vm.pessoaDetalhe(pessoa)))])]);
  })], 2) : _vm._e(), _vm.oportunidades.length ? _c('div', {
    staticClass: "crm-busca-grupo"
  }, [_c('small', {
    staticClass: "text-muted text-uppercase"
  }, [_vm._v("Oportunidades abertas")]), _vm._l(_vm.oportunidades, function (oportunidade) {
    return _c('button', {
      key: 'oportunidade-' + oportunidade.id_crm_oportunidade,
      staticClass: "crm-busca-item",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.selecionar('oportunidade', oportunidade);
        }
      }
    }, [_c('strong', [_vm._v(_vm._s(oportunidade.titulo))]), _c('small', [_vm._v(" " + _vm._s(oportunidade.contato || oportunidade.pessoa || "Sem contato") + " ")])]);
  })], 2) : _vm._e()]) : _vm._e(), _c('b-modal', {
    attrs: {
      "title": "Criar contato",
      "ok-title": "Criar contato",
      "cancel-title": "Cancelar"
    },
    on: {
      "ok": function ok($event) {
        $event.preventDefault();
        return _vm.confirmarCriacaoContato.apply(null, arguments);
      }
    },
    model: {
      value: _vm.modalCriarContato,
      callback: function callback($$v) {
        _vm.modalCriarContato = $$v;
      },
      expression: "modalCriarContato"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nome"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: _vm.novoContato.nome,
      callback: function callback($$v) {
        _vm.$set(_vm.novoContato, "nome", $$v);
      },
      expression: "novoContato.nome"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label": "WhatsApp"
    }
  }, [_c('b-form-input', {
    attrs: {
      "autocomplete": "off",
      "placeholder": "Informe o telefone com DDD",
      "type": "tel"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.confirmarCriacaoContato.apply(null, arguments);
      }
    },
    model: {
      value: _vm.novoContato.telefone,
      callback: function callback($$v) {
        _vm.$set(_vm.novoContato, "telefone", $$v);
      },
      expression: "novoContato.telefone"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Telefone mínimo para abrir oportunidade com cliente novo. ")])], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };